<div class="main audit-log-detail">
    <div class="card">
        <div class="header-section">
            <a [routerLink]="['/audit-log']" class="back-link">
                <i class="fas fa-chevron-left"></i> Back
            </a>
            <h3 class="title">Audit Log Detail</h3>
        </div>

        <div class="grid-container" *ngIf="auditlogDetail">
            <div class="grid-item">
                <label>Entity ID:</label>
                <span>{{ auditlogDetail.entityId }}</span>
            </div>

            <div class="grid-item">
                <label>Entity Name:</label>
                <span>{{ auditlogDetail.entityName }}</span>
            </div>

            <div class="grid-item">
                <label>Action Type:</label>
                <span class="badge badge-action">{{
                    auditlogDetail.actionType
                }}</span>
            </div>

            <div class="grid-item">
                <label>Status:</label>
                <span
                    class="badge"
                    [class.badge-success]="auditlogDetail.status === 'Success'"
                    [class.badge-error]="auditlogDetail.status !== 'Success'"
                >
                    {{ auditlogDetail.status }}
                </span>
            </div>

            <div class="grid-item">
                <label>IP Address:</label>
                <span>{{ auditlogDetail.ipAddress }}</span>
            </div>

            <div class="grid-item">
                <label>Updated On:</label>
                <span>{{
                    auditlogDetail.updatedOn | date: 'dd/MM/yyyy HH:mm'
                }}</span>
            </div>

            <div class="grid-item">
                <label>Updated By:</label>
                <span>{{ auditlogDetail.updatedByUser }}</span>
            </div>
        </div>

        <div
            class="changes-section"
            *ngIf="auditlogDiff && auditlogDiff.length > 0"
        >
            <h4 class="section-title">Field Changes</h4>
            <div class="table-container">
                <p-table
                    [value]="auditlogDiff"
                    responsiveLayout="scroll"
                    styleClass="audit-table"
                >
                    <ng-template pTemplate="header">
                        <tr style="border-radius: 15px;">
                            <th>Field</th>
                            <th>Old Value</th>
                            <th>New Value</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-row>
                        <tr>
                            <td>{{ row.field }}</td>
                            <td>
                                {{ row.oldValue || 'N/A' }}
                            </td>
                            <td>
                                {{ row.newValue || 'N/A' }}
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </div>
</div>
